/* AoA · Campaña «Cronómetro 3 fases» (sections/aoa-campaign-header.liquid, 2026-10-15).
   Decide la fase con la hora del SERVIDOR (cabecera Date de una petición HEAD a esta misma página) y la zona de la tienda,
   nunca con el reloj del dispositivo ni con la estimación de Liquid (la página puede venir de caché). Hace correr el reloj
   en fase 2 (lo que falta hasta el fin), lo deja en 00:00:00 en fase 3, oculta la grilla y muestra el bloque de cierre.
   Fases: antes del inicio y hasta el último día = 1; del último día al fin = 2; desde el fin = 3.
   Pruebas: con data-aoa-debug en la sección, ?aoa_now=AAAA-MM-DDTHH:MM[:SS] simula la hora de la tienda. */
(function () {
  'use strict';

  function offsetAt(ms, zone) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: zone, hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    var p = {};
    f.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, p.month - 1, +p.day, +p.hour, +p.minute, +p.second) - ms;
  }

  // «AAAA-MM-DD HH:MM[:SS]» o «AAAA-MM-DDTHH:MM[:SS]» en hora de pared de la zona → instante UTC (con horario de verano)
  function wallToUtc(text, zone) {
    var m = String(text || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!m) return NaN;
    var wall = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    var guess = wall - offsetAt(wall, zone);
    return wall - offsetAt(guess, zone); // segunda pasada por si cae en el cambio de hora
  }

  // Una fecha de la sección: epoch en segundos; «utc:AAAA-MM-DDTHH:MM:SS[Z]» (metacampo date_time: Shopify lo guarda en UTC; sin
  // zona se toma como UTC); o «AAAA-MM-DD HH:MM» en hora de la tienda (ajustes del editor, zona IANA).
  function parseWhen(text, zone) {
    var t = String(text || '').trim();
    if (!t) return NaN;
    if (/^\d{9,}$/.test(t)) return +t * 1000;
    if (t.slice(0, 4) === 'utc:') {
      var iso = t.slice(4).trim().replace(' ', 'T');
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(iso)) iso += (iso.length === 16 ? ':00' : '') + 'Z';
      return Date.parse(iso);
    }
    return wallToUtc(t, zone);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(root) {
    var d = root.dataset;
    var zone = d.aoaZone || 'America/New_York';
    var last = parseWhen(d.aoaLastDay, zone), end = parseWhen(d.aoaEnd, zone); // campaign.start es solo informativa
    var hasDates = !isNaN(last) && !isNaN(end);
    if (hasDates && end <= last) last = end; // fechas al revés: sin fase 2, del fin en adelante es fase 3
    var forced = { photo: 1, countdown: 2, ended: 3 }[d.aoaMode] || 0;
    var clock = root.querySelector('[data-aoa-clock]');
    var el = clock && { h: clock.querySelector('[data-h]'), m: clock.querySelector('[data-m]'), s: clock.querySelector('[data-s]'), sr: clock.querySelector('[data-aoa-clock-text]') };
    var announce = document.querySelector('[data-aoa-announce]');
    var skew = 0, timer, lastPhase = +d.aoaPhase || 1, lastMinuteText = '';

    // Hora simulada (solo con el ajuste de pruebas encendido)
    var sim = null;
    if ('aoaDebug' in d) {
      var q = new URLSearchParams(location.search).get('aoa_now');
      if (q) { var t = wallToUtc(q, zone); if (!isNaN(t)) sim = t - Date.now(); }
    }
    function now() { return Date.now() + (sim !== null ? sim : skew); }

    function sync() {
      if (sim !== null) return Promise.resolve();
      var t0 = Date.now();
      return fetch(location.pathname + location.search, { method: 'HEAD', cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) {
          var date = r.headers.get('Date');
          if (!date) return;
          var t1 = Date.now();
          skew = Date.parse(date) + 500 - (t0 + t1) / 2; // Date viene redondeada al segundo
        })
        .catch(function () { /* sin red: se queda con el reloj del dispositivo */ });
    }

    function phaseAt(t) {
      if (forced) return forced;
      if (!hasDates) return 1;
      return t >= end ? 3 : t >= last ? 2 : 1;
    }

    function applyPhase(phase) {
      if (phase === lastPhase && root.dataset.aoaApplied) return;
      var prev = lastPhase;
      lastPhase = phase;
      root.dataset.aoaPhase = String(phase);
      root.dataset.aoaApplied = '1';
      document.documentElement.dataset.aoaPhase = String(phase);
      document.dispatchEvent(new CustomEvent('aoa:phase', { detail: phase }));
      var st = document.querySelector('style[data-aoa-ended-style]');
      if (st) st.parentNode.removeChild(st); // desde aquí manda el atributo en <html>
      if (clock) clock.setAttribute('aria-label', phase === 3 ? 'Campaign ended' : 'Time left');
      if (phase === 3 && prev === 2 && announce) {
        var h2 = document.querySelector('.aoa-campaign-ended__heading');
        announce.textContent = h2 ? h2.textContent : 'This campaign has ended.';
      }
    }

    function paint() {
      var t = now();
      var phase = phaseAt(t);
      applyPhase(phase);
      if (!el) return phase;
      var rest = phase === 2 && hasDates ? Math.max(0, end - t) : 0; // solo en fase 2 hay cuenta; en 1 y 3 el reloj marca 0
      var sec = Math.ceil(rest / 1000); // 23:59:59.4 se muestra como 24:00:00 hasta que pase el segundo entero
      var h = Math.floor(sec / 3600), m = Math.floor(sec % 3600 / 60), s = sec % 60;
      el.h.textContent = pad(h); el.m.textContent = pad(m); el.s.textContent = pad(s);
      var minuteText = phase === 3 ? 'Campaign ended' : h + ' hours ' + m + ' minutes left';
      if (el.sr && minuteText !== lastMinuteText) { el.sr.textContent = minuteText; lastMinuteText = minuteText; }
      return phase;
    }

    // Cada tic recalcula desde el reloj (sin acumular deriva) y se alinea al cambio de segundo
    function tick() {
      clearTimeout(timer);
      var phase = paint();
      if (phase === 3 && forced !== 2) return;
      timer = setTimeout(tick, 1000 - (now() % 1000) + 5);
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sync().then(tick);
    });

    paint();
    sync().then(tick);

    // Modo pruebas: etiqueta en pantalla qué metacampo editaría cada elemento (data-aoa-field). Temporal, para acordar la
    // lista de metacampos con Marketing (2026-10-15). No se ve sin data-aoa-debug.
    if ('aoaDebug' in d) {
      var tags = [];
      // El aviso superior es una sección compartida del sitio (no se toca): solo se etiqueta aquí, en modo pruebas
      var bar = document.querySelector('.announcement-bar--static-item, .announcement-bar--item');
      if (bar) bar.setAttribute('data-aoa-field', 'campaign.announcement');
      function placeTags() {
        tags.forEach(function (t) { t.remove(); }); tags = [];
        document.querySelectorAll('[data-aoa-field]').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (!r.width || !r.height || getComputedStyle(el).display === 'none') return;
          var tag = document.createElement('span');
          tag.className = 'aoa-campaign-fieldtag';
          tag.textContent = el.getAttribute('data-aoa-field');
          tag.style.top = (r.top + window.scrollY) + 'px';
          tag.style.left = (r.left + window.scrollX + (el.tagName === 'IMG' ? r.width - 8 : 0)) + 'px';
          if (el.tagName === 'IMG') tag.style.transform = 'translateX(-100%)';
          document.body.appendChild(tag); tags.push(tag);
        });
      }
      placeTags();
      window.addEventListener('resize', placeTags);
      window.addEventListener('scroll', placeTags, { passive: true });
      document.addEventListener('aoa:phase', placeTags);
      if (window.ResizeObserver) new ResizeObserver(placeTags).observe(document.body); // la grilla cambia de alto al cargar fotos
    }
  }

  function boot() {
    document.querySelectorAll('[data-aoa-campaign]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Editor del tema: la sección se vuelve a renderizar al cambiar un ajuste
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-aoa-campaign]');
    if (root) init(root);
  });
})();
